module.exports = __webpack_public_path__ + "static/media/instant-loto.49668d10.png";